import React from 'react';

const IngredientsForm = ({
  ingredient,
  handleIngredientSubmit,
  setIngredient,
}) => {
  return (
    <div className="search-container">
      <div className="ingredients-form">
        <form onSubmit={handleIngredientSubmit} autoComplete="off">
          <input
            required
            placeholder="e.g.  chicken"
            id="standard-adornment"
            value={ingredient}
            onChange={(e) => setIngredient(e.target.value)}
          />
          <button className="btn-submit" type="submit">
            Add Ingredient
          </button>
        </form>
      </div>
    </div>
  );
};

export default IngredientsForm;
